class DriveModelModel {

  private _id: any;
  private _name: any;
  private _drivetype: any;
  private _startdate: any;
  private _enddate: any;
  private _editstartdate: any;   // ✅ ADDED
  private _editenddate: any;     // ✅ ADDED
  private _alloweditingenddate: any;
  private _jee_editing_end_date: any;
  private _details: any;

  constructor(data: any) {
    this._id = data["id"];
    this._name = data["name"];
    this._drivetype = data["drivetype"];
    this._startdate = data["startdate"];
    this._enddate = data["enddate"];
    this._editstartdate = data["editstartdate"]; // ✅ ADDED
    this._editenddate = data["editenddate"];     // ✅ ADDED
    this._alloweditingenddate = data["alloweditingenddate"];
    this._jee_editing_end_date = data["jee_editing_end_date"];
    this._details = data["details"];
  }

  public getId(): any {
    return this._id;
  }

  public setId(value: any) {
    this._id = value;
  }

  public getName(): any {
    return this._name;
  }

  public setName(value: any) {
    this._name = value;
  }

  public getDrivetype(): any {
    return this._drivetype;
  }

  public setDrivetype(value: any) {
    this._drivetype = value;
  }

  public getStartdate(): any {
    return this._startdate;
  }

  public setStartdate(value: any) {
    this._startdate = value;
  }

  public getEnddate(): any {
    return this._enddate;
  }

  public setEnddate(value: any) {
    this._enddate = value;
  }

  // ✅ ADDED
  public getEditstartdate(): any {
    return this._editstartdate;
  }

  public setEditstartdate(value: any) {
    this._editstartdate = value;
  }

  // ✅ ADDED
  public getEditenddate(): any {
    return this._editenddate;
  }

  public setEditenddate(value: any) {
    this._editenddate = value;
  }

  public getAlloweditingenddate(): any {
    return this._alloweditingenddate;
  }

  public setAlloweditingenddate(value: any) {
    this._alloweditingenddate = value;
  }

  public getJee_editing_end_date(): any {
    return this._jee_editing_end_date;
  }

  public setJee_editing_end_date(value: any) {
    this._jee_editing_end_date = value;
  }

  public getDetails(): any {
    return this._details;
  }

  public setDetails(value: any) {
    this._details = value;
  }

  public toJson(): any {
    return {
      "id": this._id,
      "name": this._name,
      "drivetype": this._drivetype,
      "startdate": this._startdate,
      "enddate": this._enddate,
      "editstartdate": this._editstartdate, // ✅ ADDED
      "editenddate": this._editenddate,     // ✅ ADDED
      "alloweditingenddate": this._alloweditingenddate,
      "jee_editing_end_date": this._jee_editing_end_date,
      "details": this._details,
    };
  }

  public static fromJson(json: any): DriveModelModel {
    return new DriveModelModel(json);
  }
}

export default DriveModelModel;